import React from 'react';
import { IconProps } from '.';

const SvgBarChart = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='m5.25 13 2.5-1v8h-2.5v-7ZM10.75 5l2.5-1v16h-2.5V5ZM16.25 8l2.5-1v13h-2.5V8Z' />
    </svg>
  );
};

export default SvgBarChart;
